import { Sparkles } from "lucide-react";
import { Container, Button } from "@/components/atoms";

// Quiz CTA (frame 58:2).
export function QuizCta() {
  return (
    <section className="py-6">
      <Container>
        <div className="flex flex-col items-center gap-4 rounded-3xl bg-healthy-blue px-6 py-10 text-center text-white md:flex-row md:justify-between md:text-left">
          <div className="flex items-center gap-4">
            <Sparkles
              size={40}
              className="hidden shrink-0 text-white sm:block"
            />
            <div>
              <h2 className="font-condensed text-2xl font-bold">
                Not sure which formula is right for you?
              </h2>
              <p className="mt-1 text-white">
                Browse the full collection and find your physician-formulated
                fit.
              </p>
            </div>
          </div>
          <Button to="/shop" variant="primary" size="lg" className="shrink-0">
            Find My Formula
          </Button>
        </div>
      </Container>
    </section>
  );
}
